export { getDoc, useDocument } from './use-swr-document';
export { getDocs, useCollection } from './use-swr-collection';
export { useCollectionGroup, useExperimentalCollectionGroup } from './use-swr-collection-group';
export { setDoc, updateDoc, deleteDoc, revalidateDoc, revalidateCollection } from './static-mutations';
//# sourceMappingURL=index.js.map